import React, { useState } from 'react';
import { Icon } from '../Icon';
import { EditMode, ButtonsWrapper, DatePicker, EditModeContainer } from './EditModal.style';
import { Select } from 'antd';
import close from '../../images/close.svg';
import success from '../../images/success.png';
import useOnClickOutside from 'use-onclickoutside';
import { variables } from '../../styles/variables';
import 'moment/locale/pl';
import moment from 'moment';
var Option = Select.Option;
var marks = ['2', '3', '3,5', '4', '4,5', '5'];
var notNumeralMarks = ['zal'];
/*  Komponent edycji oceny */
export var EditModal = function (_a) {
    var value = _a.value, onConfirm = _a.onConfirm, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, pickMarkText = _a.pickMarkText, dateDefaultValue = _a.dateDefaultValue, isMarkNumeral = _a.isMarkNumeral;
    var _c = useState(value), updatedValue = _c[0], updateValue = _c[1];
    var _d = useState(dateDefaultValue), updatedDate = _d[0], updateDate = _d[1];
    var ref = React.useRef(null);
    useOnClickOutside(ref, function (event) {
        var node = ref.current;
        var isOptionClicked = (event.target && event.target.classList.toString().includes('ant-select-item')) ||
            event.target.classList.toString().includes('ant-picker');
        if (node && !node.contains(event.target) && !isOptionClicked) {
            onClose();
        }
    });
    var onConfirmHandler = function (event) {
        onConfirm(event, updatedValue, updatedDate);
    };
    var onChangeDate = function (date) {
        updateDate(date);
    };
    var disabledDate = function (current) { return current && current > moment().endOf('day'); };
    return (React.createElement(EditModeContainer, { ref: ref },
        React.createElement(EditMode, null,
            React.createElement(Select, { defaultValue: updatedValue, onChange: updateValue, dropdownClassName: 'custom_dropdown', placeholder: pickMarkText, "data-cy": 'selectMarkUpdateValue' }, isMarkNumeral
                ? marks.map(function (mark) { return (React.createElement(Option, { value: mark, key: mark, className: 'custom_option', "data-cy": "optionMark_" + mark }, mark)); })
                : notNumeralMarks.map(function (mark) { return (React.createElement(Option, { value: mark, key: mark, className: 'custom_option', "data-cy": "optionMark_" + mark }, mark)); })),
            React.createElement(DatePicker, { onChange: onChangeDate, defaultValue: dateDefaultValue, size: 'large', popupStyle: { color: variables.colorMainText }, dropdownClassName: 'custom_calendar', disabledDate: disabledDate, "data-cy": 'datePickerMark' }),
            React.createElement(ButtonsWrapper, null,
                updatedValue && (updatedDate || dateDefaultValue) ? (React.createElement(Icon, { className: 'smaller', path: success, onClick: onConfirmHandler, dataCy: 'btnMarkConfirm' })) : null,
                React.createElement(Icon, { path: close, onClick: onClose, dataCy: 'btnMarkCancel' })))));
};
